import { render } from "./LogoFull.vue?vue&type=template&id=68bc6d80&scoped=true"
import script from "./LogoFull.vue?vue&type=script&lang=js"
export * from "./LogoFull.vue?vue&type=script&lang=js"

import "./LogoFull.vue?vue&type=style&index=0&id=68bc6d80&scoped=true&lang=css"

import exportComponent from "/Users/timothyjoseph/Projects/simplest-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68bc6d80"]])

export default __exports__